import * as React from 'react';

import * as styles from './styles.css';

export const CommunicationErrorIllustration: React.FC = () => {
  return <div className={styles['error']} />;
};
